/**
 * Material 3 motion tokens — durations and easings used for hover, focus,
 * popover open/close, and view transitions. Mirrors `--dur-*` / `--ease-*` in
 * the design handoff so the new component library has a single source of
 * truth for animation timing.
 */
export const duration = {
  fast: '120ms',
  base: '200ms',
  slow: '400ms',
};

export const easing = {
  /** Material 3 standard ease — used for everything that isn't a special-case curve. */
  standard: 'cubic-bezier(0.2, 0, 0, 1)',
  /** Slight overshoot for popovers / toasts entering. */
  emphasised: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
};

const motion = {
  duration,
  easing,
};

export default motion;
